import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section id="home" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-nude-light" data-id="element-108">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-nude/30 rounded-bl-[100px] -z-10 hidden lg:block" data-id="element-109" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-111">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-112">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-nude text-chocolate text-sm font-medium mb-6" data-id="element-113">
              <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-114" />
              Premium Healthcare Services
            </div>

            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-serif text-chocolate leading-[1.1] mb-6" data-id="element-115">
              Compassionate Care, <br data-id="element-116" />
              <span className="text-gold italic" data-id="element-117">Designed Around You</span>
            </h1>

            <p className="text-lg lg:text-xl text-chocolate/80 mb-8 leading-relaxed max-w-lg" data-id="element-118">
              Experience a new standard of personalized healthcare. We provide
              warm, human-centered support for you and your loved ones, ensuring
              comfort, dignity, and peace of mind.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-119">
              <Link to="/contact" className="inline-flex justify-center items-center gap-2 bg-chocolate text-cream px-8 py-4 rounded-full font-medium hover:bg-gold hover:text-white transition-all duration-300 shadow-md hover:shadow-lg group" data-id="element-120">
                Book Appointment
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-121" />
              </Link>
              <Link to="/services" className="inline-flex justify-center items-center px-8 py-4 rounded-full font-medium text-chocolate border-2 border-chocolate/20 hover:border-chocolate transition-colors duration-300" data-id="element-122">
                Learn More
              </Link>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-123">
            <div className="relative rounded-[2rem] overflow-hidden shadow-soft-lg aspect-[4/5] lg:aspect-square" data-id="element-124">
              <img src="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&q=80&w=2000" alt="A caring healthcare professional smiling warmly with an older adult patient" className="w-full h-full object-cover" data-id="element-125" />
              {/* Overlay gradient for warmth */}
              <div className="absolute inset-0 bg-gradient-to-tr from-chocolate/20 to-transparent mix-blend-overlay" data-id="element-126" />
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8,
            duration: 0.6
          }} className="absolute -bottom-6 -left-6 lg:-left-12 bg-white p-6 rounded-2xl shadow-soft-lg max-w-[240px]" data-id="element-127">
              <div className="flex items-center gap-4 mb-2" data-id="element-128">
                <div className="flex -space-x-3" data-id="element-129">
                  {[11, 12, 13].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-nude overflow-hidden" data-id="element-130">
                      <img src={`https://i.pravatar.cc/100?img=${i}`} alt="Patient avatar" className="w-full h-full object-cover" data-id="element-131" />
                    </div>)}
                </div>
                <div className="text-gold font-bold text-xl" data-id="element-132">5.0</div>
              </div>
              <p className="text-sm text-chocolate/80 font-medium" data-id="element-133">
                Trusted by 500+ families in the community
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}